import type { QueueItem } from "../hooks/useUploadQueue";
import { humanSize } from "../util/humanSize";

type Props = {
  item: QueueItem;
  onAbort: (id: string) => void;
};

export function UploadQueueRow({ item, onAbort }: Props) {
  const pct =
    item.status === "done" ? 100 : item.total > 0 ? Math.round((item.loaded / item.total) * 100) : 0;
  return (
    <div className="rounded border border-ink/10 p-2">
      <div className="flex items-center justify-between gap-2">
        <span className="truncate text-sm">{item.file.name}</span>
        <span className="text-xs text-ink/60">
          {humanSize(item.loaded)} / {humanSize(item.total)}
        </span>
      </div>
      <div className="mt-1 h-1.5 w-full overflow-hidden rounded bg-ink/10">
        <div
          className="h-full bg-ink transition-[width]"
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="mt-1 flex items-center justify-between text-xs">
        <span className="text-ink/60">
          {item.status === "queued" && "Jonossa"}
          {item.status === "uploading" && "Lähetetään…"}
          {item.status === "done" && "Valmis"}
          {item.status === "aborted" && "Peruutettu"}
          {item.status === "error" && `Epäonnistui: ${item.error ?? "tuntematon"}`}
        </span>
        {(item.status === "queued" || item.status === "uploading") && (
          <button
            type="button"
            className="rounded border border-ink/30 px-2 py-0.5"
            onClick={() => onAbort(item.id)}
          >
            Peruuta
          </button>
        )}
      </div>
    </div>
  );
}
